<template>
  <div class="profile-listing-item">
    <div class="result-block">
      <div class="result-block-inner">

        <!-- Profile Block -->
        <div class="profile-block">
          <div class="profile-avatar">
            <img v-if="stylist.avatar" :src="stylist.avatar" :alt="fullName" />
            <img v-else-if="generalOptions.app_id === 1" src="../assets/images/rms-logo.png" :alt="fullName" />
            <img v-else-if="generalOptions.app_id === 2" src="../assets/images/rmb-logo.png" :alt="fullName" />
          </div>

          <div class="name-block">
            <!-- Rating -->
            <span class="rating-wrap w-inline-block">
              <div class="rating-star-block">
                <Rating :rate="stylist.rate" />
              </div>
              <div class="review-count">({{ stylist.reviews_number }})</div>
            </span>

            <!-- Name -->
            <div class="name">
              <a :href="profileUrl" target="_blank">{{ fullName }}</a>
            </div>

            <!-- Profession & Address -->
            <div class="user-meta">
              <div v-if="stylist.profession.length" class="title">
                {{ getProfessionsLabel(stylist.profession) }}
              </div>

              <div class="address">
                <div v-if="stylist.profile.address" class="address-line-1">
                  {{ stylist.address }}
                </div>

                <div v-if="stylist.profile.city" class="address-line-2">
                  {{ stylist.profile.city }}, {{ stylist.profile.state }} {{ stylist.profile.zip }}
                </div>
              </div>
            </div>
          </div>

          <!-- Share Menu -->
          <div class="share-menu-drop w-dropdown" role="menu">
            <span @click="showMenu = !showMenu" @focusout="showMenu = false" class="share-menu-toggle w-dropdown-toggle"
              tabindex="0" style="outline: 0">
              <span class="general-icon square-menu share-menu-icon"></span>
            </span>

            <nav class="share-menu-drop-list w-dropdown-list" :class="{ open: showMenu }">
              <!-- <span @mousedown="onMenuItemClick('like')" class="share-menu-drop-link w-inline-block">
                <span class="general-icon heart share-link-icon"></span>
                <div>{{ $t('search.listing.like') }}</div>
              </span> -->

              <span v-on:mousedown="onMenuItemClick(stylist, 'like')"
                :class="{ liked: profileLikes.indexOf(stylist.id) !== -1 }" class="share-menu-drop-link w-inline-block">
                <span class="general-icon heart share-link-icon"></span>
                <div>{{ $t('search.listing.like') }}</div>
              </span>

              <span @mousedown="onMenuItemClick(stylist, 'rate')" class="share-menu-drop-link w-inline-block">
                <span class="general-icon star share-link-icon"></span>
                <div>{{ $t('search.listing.rateIt') }}</div>
              </span>

              <span @mousedown="onMenuItemClick(stylist, 'share')" class="share-menu-drop-link w-inline-block">
                <span class="general-icon share share-link-icon"></span>
                <div>{{ $t('search.listing.share') }}</div>
              </span>
            </nav>
          </div>
        </div>

        <!-- Salon Link -->
        <div class="shop-url-wrap">
          <a v-if="stylist.salon_url" :href="stylist.salon_url">{{ stylist.salon_name }}</a>
        </div>

        <!-- Portfolio Carousel -->
        <SimpleCarousel :images="stylist.portfolio_images" transition="fade" />
      </div>

      <!-- Action Buttons -->
      <div class="w-layout-grid thumb-action-grid">
        <a :href="profileUrl" target="_blank" class="ghost-button extra-small w-button">
          {{ $t('search.listing.viewProfile') }}
        </a>

        <span class="button w-button" v-if="stylist.accept_website_booking == 1" @click="profileSelected">
          {{ $t('search.listing.bookNow') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../services/apiEndpoints";
import messages from "../services/messages";
import general from "../services/general";
import auth from "../services/auth";
import Rating from "./Rating.vue";
import SimpleCarousel from "./admin/general-components/SimpleCarousel.vue";

export default {
  name: "ProfileListingItem",

  props: {
    stylist: { type: Object, required: true }
  },

  data() {
    return {
      currentImage: 0,   // <-- LOCAL CAROUSEL STATE
      showMenu: false,
      profileLikes: [],
    };
  },

  computed: {
    fullName() {
      return `${this.stylist.first_name} ${this.stylist.last_name}`;
    },

    profileUrl() {
      return this.generalOptions.profile_url + this.stylist.profile_url;
    },

    hasImages() {
      return Array.isArray(this.stylist.portfolio_images) &&
        this.stylist.portfolio_images.length > 0;
    }
  },

  mounted: function () {
    this.user = auth.state.user;
    this.profileLikes = this.profileLikes = general.methods.getProfileLikes();
  },


  methods: {

    getProfessionsLabel(professions) {
      return professions.map((p) => p.profession).join(", ");
    },

    profileSelected() {
      this.$emit("modalProfileSelected", this.stylist);
    },
   
    onMenuItemClick(stylist, item) {
      if (item == "rate") {
        window.open(this.profileUrl + "#reviews", "_blank").focus();
        
      }

      if (item == "like") {
        if (this.profileLikes.indexOf(stylist.id) != -1) {
          return;
        }

        this.$http
          .post(api.actions.update_profile_likes, { userid: stylist.id })
          .then(
            function (response) {
              if (response.data.error == true) {
                return false;
              }

              let likes = general.methods.getCookie("profile_likes");
              likes += likes.length ? "," + stylist.id : stylist.id;
              general.methods.setCookie("profile_likes", likes, 365);

              this.profileLikes = general.methods.getProfileLikes();
              messages.successMessage(messages.GLOBAL_MESSAGES.PROFILE_LIKE);
              stylist.liked_profile = true;
            }.bind(this)
          );
      }

      if (item == "share") {
        this.$emit("shareProfileSelected", stylist);
      }
    },

    getProfileUrl(stylist) {
      return this.generalOptions.profile_url + stylist.profile_url;
    },


  },

  components: { Rating, SimpleCarousel }
};
</script>